<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<div class="md-layout">
							<!-- <div class="md-layout-item md-small-size-100 md-size-100">
								<h3>ព័ត៌មានអតិថិជន</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">

								<md-table>
									<md-table-row>
										<md-table-cell style="width: 40%;">លេខកូដអតិថិជន</md-table-cell>
										<md-table-cell style="width: 5px">:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.hash_id).length > 0">{{client.hash_id}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.name).length > 0">{{client.name}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-table>
									<md-table-row>
										<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
									<md-table-row>
										<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
										<md-table-cell>:</md-table-cell>
										<md-table-cell>
											<span v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
											<span v-else>N/A</span>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div> -->
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>ផ្លាស់ប្តូពាក្យសំងាត់</h3>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-50">
								<div class="md-layout">
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-field>
											<label>ពាក្យសំងាត់ចាស់</label>
											<md-input type="password" v-model="old_password" />
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>ពាក្យសំងាត់ថ្មី</label>
											<md-input type="password" v-model="new_password" />
										</md-field>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-50">
										<md-field>
											<label>បញ្ជាក់ពាក្យសំងាត់ថ្មី</label>
											<md-input type="password" v-model="confirm_password" />
										</md-field>
									</div>
									<div class="md-layout-item md-size-100 text-right">
										<md-button class="md-raised md-primary" @click="changePassword()">ផ្លាស់ប្តូរ</md-button>
									</div>
								</div>

							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				client: {
					hash_id: "XXA56963",
					name: "SOCHETRA",
					phone: "092988858",
					created_date: 1687074450
				},
				old_password: "",
				new_password: "",
				confirm_password: ""
			}
		},
		methods: {
			changePassword() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/client/client/new_password", {
						old_password: this.old_password,
						new_password: this.new_password,
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ពាក្យសំងាត់បានផ្លាស់ប្តូរដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.$router.push('/dashboard');
						}
					})
				}
			},
			checkValidation() {
				if (String(this.old_password).length > 5 && String(this.new_password).length > 5 && String(this.new_password) == String(this.confirm_password)) {
					return true;
				} else {
					if (String(this.old_password).length == 0 || String(this.new_password).length == 0 || String(this.confirm_password).length == 0) {
						this.$notification.notify({
							message: "សូមបំពេញព័ត៌មាន។",
							icon: 'error',
							type: 'danger'
						})
					} else if (this.new_password.length < 6) {
						this.$notification.notify({
							message: "ពាក្យសំងាត់ថ្មីត្រូវមានអក្សរចាប់ពី ៦តួរឡើង។",
							icon: 'error',
							type: 'danger'
						})
					} else if (this.new_password != this.confirm_password) {
						this.$notification.notify({
							message: "បញ្ជាក់ពាក្យសំងាត់ថ្មីមិនត្រឹមត្រូវ។",
							icon: 'error',
							type: 'danger'
						})
					}
					return false;
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Settings.vue